import { create } from "zustand";
import {
  initialEmployeePageState,
  EmployeeItemData,
  EmployeeListStateType,
} from "../core/_model";
import { ActionsKey } from "../../../../common/models/Actions";
// import { ActionsKey } from '../../../../common/models/Actions';
// import { RoleSelectListResponse } from '../../../../common/models/Roles';

export type ActionedEmployee = { data: EmployeeItemData; action: ActionsKey };

type EmployeeData = {
  employeeList: any;
  setEmployeeList: (access: any) => void;
  actioned: ActionedEmployee | null;
  setActioned: (act: ActionedEmployee | null) => void;
  needToRefresh: number;
  totalItems: number;

  setNeedToRefresh: (r: number) => void;
  // roleList: RoleSelectListResponse | null;
  // setRoleList: (roles: RoleSelectListResponse | null) => void;
};

export const useEmployeeStore = create<EmployeeData>((set) => ({
  employeeList: null,
  actioned: null,
  totalItems: 0,
  needToRefresh: 1,
  setEmployeeList: (mtl) =>
    set((state) => ({
      employeeList: mtl?.member,
      totalItems: mtl?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act })),
  setNeedToRefresh: (r) => set((state) => ({ needToRefresh: r })),
}));

export const useEmployeeListState = create<EmployeeListStateType>((set) => ({
  pageState: initialEmployeePageState,
  setPageState: (pageState) => set((state) => ({ pageState })),
  resetPageState: () =>
    set(() => ({
      pageState: {
        page: 1,
        itemsPerPage: 10,
        pagination: true,
      },
    })),
}));
